import { debounce } from "../../../../themes/loveli-theme/src/js/components/debounce";

const isCart = document.querySelector("body.woocommerce-cart") || false;
const miniCart = document.querySelector("#offcanvas-cart") || false;
const checkout = document.querySelector("body.woocommerce-checkout:not(.woocommerce-order-received)") || false;

window.dataLayer = window.dataLayer || [];

/**
 * Check If GTM is already here
 */
if (window.dataLayer.find((element) => element["gtm.start"])) {
	initGtm();
} else {
	document.addEventListener("gtm_loaded", initGtm);
}

/**
 * Kicks off all of GTM's fun
 *
 * @returns {void}
 */
function initGtm() {
	console.log("GTM Initializing...");
	gtmEventAddToCart();
	gtmEventViewCart();
	gtmEventAddPaymentInfo();

	// Sometimes we want to push something on page load (like view_cart & view_item). This will be made available by php
	if (["complete", "interactive"].includes(document.readyState)) {
		pushOnLoad();
	} else {
		document.addEventListener("DOMContentLoaded", pushOnLoad);
	}
}

/**
 * Recursively tries to convert strings to numbers
 *
 * @param {object} object
 * @return {object}
 */
function doNumbersConversion(object) {
	const convertUs = ["discount", "price", "quantity", "value", "tax", "shipping"];

	convertUs.forEach((entry) => {
		if (typeof object === "object" && object !== null) {
			if (entry in object) object[entry] = Number(object[entry]);
			if ("ecommerce" in object) doNumbersConversion(object.ecommerce);
		}
	});

	Object.values(object).forEach((value) => {
		if (Array.isArray(value))
			value.forEach((recursiveValue) => {
				doNumbersConversion(recursiveValue);
			});
	});

	return object;
}

/**
 * Pushes preset gtm information if made available on the page
 *
 * @return {void}
 */
function pushOnLoad() {
	if (typeof window.gtmPushOnLoad === "object" && window.gtmPushOnLoad !== null) {
		doNumbersConversion(window.gtmPushOnLoad);

		window.dataLayer.push({ ecommerce: null });
		window.dataLayer.push(window.gtmPushOnLoad);
	}
}

/**
 * Adds the needed listeners for the add_to_cart and remove_from_cart events
 *
 * @return {void}
 */
function gtmEventAddToCart() {
	let isProductPage = document.querySelector("body.single-product") ? true : false;
	let variableProductForm = isProductPage ? document.querySelector("form.variations_form") : false;

	// Set the data-gtm-ecommerce on variable product pages
	if (isProductPage && variableProductForm) {
		let gtmInfo = window.loveliGtmVariationInfo;
		let submitButton = variableProductForm.querySelector('button[type="submit"]');
		let selectEl = variableProductForm.querySelector("select");
		let selectedIndex = selectEl.options.selectedIndex;

		if (selectedIndex === 0) {
			// Maybe we are using 'option none' on this product
			const optionHasValue = selectEl[0].value || false;
			if (optionHasValue) submitButton.setAttribute("gtm-ecommerce", gtmInfo[selectedIndex]);
		} else {
			submitButton.dataset.gtmEcommerce = JSON.stringify(gtmInfo[selectedIndex]);
		}

		submitButton.dataset.gtmEvent = "add_to_cart";

		variableProductForm.addEventListener("change", (e) => {
			selectedIndex = selectEl.options.selectedIndex;

			submitButton.dataset.gtmEcommerce = JSON.stringify(gtmInfo[selectedIndex]);
		});
	}

	// Add to cart actions and remove from cart actions
	document.addEventListener("click", (e) => {
		if (["add_to_cart_button", "product_type_variable"].every((className) => e.target.classList.contains(className))) return;
		if (!e.target.dataset.gtmEcommerce) return;

		let gtmEcommerce = JSON.parse(e.target.dataset.gtmEcommerce);

		if (isProductPage) {
			gtmEcommerce.items[0].quantity = parseInt(document.querySelector('form.cart input[name="quantity"]').value);
		}

		doNumbersConversion(gtmEcommerce);

		window.dataLayer.push({
			ecommerce: null,
		});

		window.dataLayer.push({
			event: e.target.dataset.gtmEvent,
			ecommerce: gtmEcommerce,
		});
	});

	// Cart actions
	["input", "click"].forEach((event) => {
		document.addEventListener(event, function (e) {
			let cart = isCart ? document.querySelector("form.woocommerce-cart-form") : miniCart;

			if (cart === miniCart) return;
			// If the event is input, but the input is null (like backspace)

			if (e.inputType == "deleteContentBackward" || e.inputType == "deleteContentForward") return;

			if (event === "input" && !e.target.classList.contains("qty")) return;
			if (event === "click" && !e.target.classList.contains("qty_button")) return;

			let itemEl = e.target.closest(".cart_item");

			let gtmEcommerce = JSON.parse(itemEl.querySelector("[data-gtm-ecommerce]").dataset.gtmEcommerce);

			doNumbersConversion(gtmEcommerce);

			debounce(function () {
				let oldQty = gtmEcommerce.items[0].quantity;
				let newQty = itemEl.querySelector(".qty").value;
				let gtmQty = newQty - oldQty;
				let gtmEvent = gtmQty > 0 ? "add_to_cart" : "remove_from_cart";
				gtmEcommerce.items[0].quantity = Math.abs(gtmQty); // Make it always positive

				window.dataLayer.push({ ecommerce: null });
				window.dataLayer.push({
					event: gtmEvent,
					ecommerce: gtmEcommerce,
				});
			}, 350);
			// }
		});
	});
}

/**
 * Adds the needes listeners for the view_cart event
 *
 * @return {void}
 */
function gtmEventViewCart() {
	miniCart.addEventListener("shown.bs.offcanvas", (e) => {
		setTimeout(() => {
			let gtmItemsEl = miniCart.querySelectorAll("[data-gtm-ecommerce]");

			if (gtmItemsEl.length == 0) return;

			let gtmItems = [...gtmItemsEl].map(function (itemEl) {
				return doNumbersConversion(JSON.parse(itemEl.dataset.gtmEcommerce).items[0]);
			});

			let gtmValue = Number(miniCart.querySelector(".total .amount").innerText.replace("-", ""));

			let gtm = {
				event: "view_cart",
				ecommerce: {
					currency: "EUR",
					value: gtmValue,
					items: gtmItems,
				},
			};

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({ ecommerce: null });
			window.dataLayer.push(gtm);
		}, 500);
	});
}

/**
 * Adds the needed listeners for the add_shipping_info event
 *
 * @returns {void}
 */
function gtmEventAddPaymentInfo() {
	if (!checkout) return;

	const checkoutForm = document.querySelector('form[name="checkout"]');

	checkoutForm.addEventListener("submit", function (e) {
		if (typeof window.gtmPushOnLoad === "object" && window.gtmPushOnLoad !== null) {
			let gtm = window.gtmPushOnLoad;

			gtm.ecommerce.payment_type = checkout.querySelector('input[name="payment_method"]:checked').value;
			gtm.event = "add_payment_info";

			window.dataLayer.push({
				ecommerce: null,
			});

			window.dataLayer.push(gtm);
		}
	});
}
